import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { Patrol } from './components/Bear';
import { loginUrl } from '../pages/Auth/microsoftLogin';

// The V3 sign-in: the same Microsoft sign-in as the current site, and back to V3 afterwards.
export default function V3SignIn() {
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const returnUrl = new URLSearchParams(window.location.search).get('returnUrl');
  const target = returnUrl && returnUrl.startsWith('/v3') ? returnUrl : '/v3';

  useEffect(() => {
    if (isAuthenticated()) navigate(target);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="signin">
      <div className="card">
        <div className="card-body">
          <Patrol size={52} />
          <h1><b>CMA</b> V3</h1>
          <p>Sign in with your CMA Technology account.</p>
          <button type="button" className="btn btn-primary" onClick={() => { window.location.href = loginUrl(target); }}>Sign in with Microsoft</button>
        </div>
      </div>
    </div>
  );
}
